// extracted by mini-css-extract-plugin
export default {"list":"app_list__OubwN","loading":"app_loading__J3Ig6","error":"app_error__dqRgY"};